import { Injectable } from '@angular/core';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';
import { ProfileService } from '@services/profile/profile.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter, first } from 'rxjs';
import { CallcardDetailStampsFreetext } from '../../../components/callcard-detail-stamps-freetext/callcard-detail-stamps-freetext.component';
import { CardToolsButton } from '../../../schema/card-tools-button';
import { ButtonsProviderService } from '../../buttons-provider/buttons-provider.service';
import { CardToolsButtonControllerService } from '../../card-tools-button-controller/card-tools-button-controller.service';
import { CardsProviderService } from '../../cards-provider/cards-provider.service';

@AddinExecute({
  name: 'CallcardSetup',
  description: 'Setup the callcard details view'
})
@Injectable()
export class CallcardSetupService extends Execute {
  constructor(
    private profileService: ProfileService,
    private profileReader: ProfileReaderService,
    private cardsProvider: CardsProviderService,
    private buttonsProvider: ButtonsProviderService,
    private cardToolsButtonController: CardToolsButtonControllerService
  ) {
    super();
  }

  execute() {
    this.profileService.ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => {
        const showFreeTextTypes: number[] = this.profileReader.getComponentConfig('singlecallcard', 'showFreeTextTypes', []);
        if (showFreeTextTypes?.length) {
          this.cardsProvider.add(CallcardDetailStampsFreetext);
        }

        const cardToolsButton: CardToolsButton = new CardToolsButton();
        this.cardToolsButtonController.setup(cardToolsButton);
        this.buttonsProvider.add(cardToolsButton);
      });
  }
}
